function RatingStars({ rating }) {
  const maxBowls = 5;
  const fullBowls = Math.floor(rating); // Full bowls
  const hasHalfBowl = rating % 1 >= 0.5; // Check if there's a half bowl

  return (
    <div className="flex justify-center gap-2">
      {[...Array(maxBowls)].map((_, index) => {
        // Determine if this bowl is full, half, or empty
        const isFull = index < fullBowls;
        const isHalf = index === fullBowls && hasHalfBowl;
        const isEmpty = !isFull && !isHalf;

        return (
          <div
            key={index}
            className={`relative inline-block transition-all ${
              isFull ? "opacity-100" : isEmpty ? "opacity-30 grayscale" : ""
            }`}
            style={{
              width: '48px',
              height: '48px',
              filter: isFull ? "drop-shadow(0 0 8px rgba(251, 191, 36, 0.8))" : "none"
            }}
          >
            {isHalf ? (
              <>
                {/* Empty bowl background */}
                <img 
                  src="/ramen-bowl.png" 
                  alt="Ramen bowl" 
                  className="w-full h-full opacity-30 grayscale"
                />
                {/* Half bowl overlay: full-size colored image clipped to left half */}
                <img 
                  src="/ramen-bowl.png" 
                  alt="Ramen bowl"
                  className="absolute top-0 left-0 w-full h-full"
                  style={{ 
                    clipPath: 'inset(0 50% 0 0)',
                    filter: 'drop-shadow(0 0 8px rgba(251, 191, 36, 0.8))',
                    willChange: 'clip-path'
                  }}
                />
              </>
            ) : (
              <img 
                src="/ramen-bowl.png" 
                alt="Ramen bowl" 
                className="w-full h-full"
              />
            )}
          </div>
        );
      })}
    </div>
  );
}

export default RatingStars;
